<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ address ? 'Update Address' : 'Add Address' }}
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Address 1*">
          <d-input v-model="addressForm.address1" :required="true" />
        </d-field>
        <d-field label="Address 2">
          <d-input v-model="addressForm.address2" />
        </d-field>
        <d-field label="City*">
          <d-input v-model="addressForm.city" :required="true" />
        </d-field>
        <d-field label="State*">
          <d-state-selector v-model="addressForm.province" return-abbrev />
        </d-field>
        <d-field label="Zip*">
          <d-input v-model="addressForm.postalCode" :required="true" />
        </d-field>
        <d-field label="Type*">
          <d-select v-model="addressForm.type" placeholder="Select community" required>
            <option value="Home">
              Home
            </option>
            <option value="School">
              School
            </option>
          </d-select>
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn
          :loading="saving"
          type="submit"
        >
          {{ address ? 'Update Address' : 'Add Address' }}
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      address: {
        type: Object,
        default: () => {},
      },
      userId: {
        type: String,
        default: () => '',
      },
    },

    data: () => ({
      saving: false,
      addressForm: {
        address1: '',
        address2: '',
        city: '',
        province: '',
        postalCode: '',
        type: '',
        userId: '',
      },
    }),

    mounted() {
      if (this.address) {
        this.addressForm = JSON.parse(JSON.stringify(this.address));
      }
      this.addressForm.userId = this.userId;
    },

    methods: {
      async saveForm() {
        this.saving = true;
        try {
          if (this.address) {
            await axios.patch(
              `/api/user/addresses/${this.address.id}`,
              this.addressForm,
            );
          } else {
            await axios.post(`/api/user/${this.userId}/addresses`, this.addressForm);
          }
          this.$toast.success('Address saved!');
          await this.$parent.events.getPaged();
          this.$parent.close();
        } catch (error) {
          this.$toast.open({ message: error.response.data[0], color: 'red-500', duration: 4000 });
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>